<template>
    <div :class="appendedClass">
        <!-- unfollow confirmation dialog -->
        <ConfirmationDialog ref="ConfirmationDialogRef" :confirmationDialogData="confirmationDialogData" :isLoading="followingInProgress"/>
        <!-- button in multiple designs -->
        <!-- design 2 -->
        <button v-if="designId == 2" @click.stop.prevent="onButtonClick" type="button"
            :aria-label="buttonTitle" :title="buttonTitle"
            :class="`px-2 py-2 md:py-3 inline-flex justify-center items-center gap-1.5 select-none text-center flex-nowrap whitespace-nowrap w-full max-w-[7.313rem] cursor-pointer ${followed ? 'bg-[#EF1D2B]' : 'bg-primary'} hover:brightness-95 transition-colors duration-150 text-[0.75rem] font-normal text-white rounded-[0.313rem]`">
            <span class="ellipsis-x1">{{ buttonTitle }}</span>
        </button>
        <!-- design 3 -->
        <button v-else-if="designId == 3" @click.stop.prevent="onButtonClick" type="button"
            :aria-label="buttonTitle" :title="buttonTitle"
            :class="`px-3 py-2 md:py-2.5 inline-flex justify-center items-center gap-1.5 select-none text-center flex-nowrap whitespace-nowrap w-full max-w-[8.5rem] cursor-pointer ${followed ? 'bg-[#EF1D2B]' : 'bg-primary'} hover:brightness-95 transition-colors duration-150 text-[0.875rem] font-normal text-white rounded-[0.313rem]`">
            <svg v-if="followed" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4m7 6.586l2.121-2.121l1.415 1.414L20.414 19l2.121 2.121l-1.414 1.415L19 20.414l-2.121 2.121l-1.415-1.414L17.587 19l-2.121-2.121l1.414-1.415z"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32"><path fill="currentColor" d="M32 14h-4v-4h-2v4h-4v2h4v4h2v-4h4zM12 4a5 5 0 1 1-5 5a5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7a7 7 0 0 0-7-7m10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z"/></svg>
            <span class="ellipsis-x1">{{ buttonTitle }}</span>
        </button>
        <!-- default design 1 -->
        <button v-else @click.stop.prevent="onButtonClick" type="button"
            :aria-label="buttonTitle" :title="buttonTitle"
            :class="`px-2 inline-flex items-center gap-1.5 select-none flex-nowrap whitespace-nowrap w-max py-1.5 cursor-pointer ${followed ? 'bg-[#EF1D2B]' : 'bg-primary'} hover:brightness-95 transition-colors duration-150 text-[12.2px] sm:text-[12.3px] md:text-[12.5px] xl:text-[12.7px] font-bold text-white rounded-[4px]`">
            <span class="ellipsis-x1">{{ buttonTitle }}</span>
            <img :src="followed ? UnfollowIcon : FollowIcon" alt width="20" height="20" class="w-[15px] h-[15px] sm:w-[16px] sm:h-[16px] md:w-[20px] md:h-[20px]">
        </button>
    </div>
</template>

<script>
import { ConfirmationDialog } from "@/components";
import FollowIcon from "@/assets/icons/follow.svg";
import UnfollowIcon from "@/assets/icons/unfollow.svg";

export default {
    data() {
        return {
            FollowIcon,
            UnfollowIcon,
            confirmationDialogData:{
                title:'',
                isDangerous: true,
                confirmedFunc:()=>{},
            },
        }
    },
    components: {
        ConfirmationDialog
    },
    props: {
        storeName: {
            type: String,
            default: "",
            required: true
        },
        toggleFollowingState: {
            type: Function,
            required: true
        },
        followed: {
            type: [Boolean, Number],
            default: false,
            required: true
        },
        followingInProgress: {
            type: Boolean,
            default: false,
            required: true
        },
        designId: {
            type: Number,
            default: 1,
            required: false
        },
        appendedClass: {
            type: String,
            default: "",
            required: false
        }
    },
    computed: {
        buttonTitle() {
            switch(this.designId){
                case 2:
                case 3:
                    return this.followed ? this.$t('user.unfollow_store') :  this.$t('user.follow');
                default:
                    return this.followed ? this.$t('user.unfollow_store') :  this.$t('user.follow_store');
            }
        }
    },
    methods: {
        openConfirmationDialog(){
            this.confirmationDialogData={
                ...this.confirmationDialogData,
                title: this.$t('user.unfollow_store_confirmation', {storeName: this.storeName}),
                confirmedFunc: () => this.toggleFollowingState()
            }; 
            this.$refs.ConfirmationDialogRef.openModal()
        },
        onButtonClick(){
            if(this.followingInProgress || !process.client) return;
            if(this.followed){
                this.openConfirmationDialog();
            }else{
                this.toggleFollowingState();
            }
        },
    }
}
</script>

<style></style>